import { Icon } from 'semantic-ui-react';

type MappingsAlternativesIndicationPropsType = {
    highlightAlternatives: () => void;
    unhighlightAlternatives: () => void;
};

function MappingsAlternativesIndication({
    highlightAlternatives,
    unhighlightAlternatives,
}: MappingsAlternativesIndicationPropsType) {
    return (
        <Icon
            onPointerEnter={highlightAlternatives}
            onPointerLeave={unhighlightAlternatives}
            color="blue"
            name="info"
        />
    );
}

export default MappingsAlternativesIndication;
